<template>
  <div v-on-clickaway="away" class="flyout-container" v-bind="props">
    <div @click="flyoutOpen = !flyoutOpen" >
      <slot name="toggler"/>
    </div>

    <div class="flyout" :class="{open: flyoutOpen}">
      <slot name="togglable" :close="close"/>
    </div>
  </div>
</template>

<script>
import style from 'brave-flyout/components/flyout.scss'
import { mixin as clickaway } from 'vue-clickaway'
let flyoutOpen = false
export default {
  mixins: [clickaway],
  data () {
    let props = this.$attrs
    return {
      props,
      flyoutOpen
    }
  },
  methods: {
    away: function() {
      this.close()
    },
    close: function () {
      this.flyoutOpen = false
    },
    open: function () {
      this.flyoutOpen = true
    },
    toggle: function () {
      this.flyoutOpen = !this.flyoutOpen
    }
  }
}
</script>